import React, { useState, useEffect, useContext } from 'react';
import { environment } from '../global/environment';
import { DataModel } from '../models/DataModel';
import { WebTagContext } from '../context/WebTagContext';
import { ResponseModel } from '../models/ResponseModel';

export const useFetch = ( url, endpoint, type = 'GET', send = false, setSend = null ) => { 

    const [state, setState] = useState( new ResponseModel() );

    const { userData, tagCar, loading, setLoading, setUserData } = useContext(WebTagContext);
    

    const { document_types_endpoint, 
            add_tag_endpoint,
            car_brands_endpoint } = environment;

    useEffect(() => {
        if( type !== 'GET' && !send ){
            //setState( new ResponseModel( null, [] ) );
            return;
        }

        const options = type === 'GET' ? 
                        {} :
                        {
                            method: type,
                            body: JSON.stringify({
                                ...userData,
                                ...tagCar,
                                dob: parseDob()
                            }),
                            headers: {
                                "Content-type": "application/json; charset=UTF-8"
                            }
                        };
        if( endpoint !== `${car_brands_endpoint}//models` ){
            let endp = endpoint;
            if( endpoint.includes('/models') ){
                endp = 'car_models';
            }

            setLoading({
                ...loading,
                [ endp ]: true
            });

            fetch( url + endpoint, options )
                .then( resp => resp.json() )
                .then( data => {
                    let response = [];
                    switch( endpoint ){
                        case 'document_types':
                            data._embedded?.document_type.map( 
                                element =>  {
                                    const el = new DataModel( element.id, element.name );
                                    response = [ ...response, el ];
                                }
                            );
                            setLoading({
                                ...loading,
                                [ endp ]: false
                            });
                            setState( new ResponseModel( true, response ) );
                            setUserData({
                                ...userData,
                                documentType: '1'
                            })

                            break;
                        case 'parking_conditions':
                            setState( new ResponseModel( false, { __html: data?.conditions } ) );
                            break;
                        case 'add_tag_request':
                            const newState = data.status && data.status !== 200 ? 
                                            new ResponseModel( false, data?.detail ) : 
                                            new ResponseModel( true, data?.transaction );
                            setSend( false );

                            setLoading({
                                ...loading,
                                [ endp ]: false
                            });

                            setState( newState );
                            break;
                        default:
                                data.data?.map( 
                                    element =>  {
                                        const el = new DataModel( element.id, element.name );
                                        response = [ ...response, el ];
                                    }
                                );
                            
                                setLoading({
                                    ...loading,
                                    [ endp ]: false
                                });
                                setState( new ResponseModel( true, response ) );
                            break;
                    }
                    
                } );
            }
    }, [ endpoint, send ]);

    const parseDob = () => {
        const dobSplit = userData.dob.split('-');
        return `${ dobSplit[2] }-${ dobSplit[1] }-${ dobSplit[0] }`;
    }

    return state;
    

}
